import type maplibregl from "maplibre-gl";

let lib: typeof maplibregl | null = null;
let libPromise: Promise<typeof maplibregl> | null = null;

export function loadMaplibre(): Promise<typeof maplibregl> {
  if (!libPromise) {
    libPromise = import("maplibre-gl").then((m) => {
      lib = ((m as { default?: typeof maplibregl }).default ?? (m as unknown as typeof maplibregl));
      return lib;
    });
  }
  return libPromise;
}

export function getMaplibre(): typeof maplibregl {
  if (!lib) {
    throw new Error("maplibre-gl not loaded yet — await loadMaplibre() first");
  }
  return lib;
}
